import React, {useCallback, useEffect, useRef, useState} from "react"
import {Button} from "devextreme-react/button"
import Form, {
    GroupItem,
    Item,
    Label,
    RequiredRule,
    StringLengthRule,
    PatternRule,
    CompareRule,
    EmptyItem,
    ButtonItem,
    ButtonOptions, CustomRule, EmailRule
} from "devextreme-react/form"
import RadioGroup from 'devextreme-react/radio-group';
import './add-dogovor.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines, faKey, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import Accordion, {Item as AccItem} from "devextreme-react/accordion";
import notify from "devextreme/ui/notify";
import {
    addFilesToOldReq, checkINN, clientSignRefused, isInnReadyForBackendCheck,
    daDataGet, deleteNewDogReq, delRequestAttach, getDogDocList,
    getDogKind, getDogovorToSigned, getDogovorZip, getDogovorZipAll,
    getFinalDogovor, getMessages, getConsumerTypes, getObjTypes, getDocReceive, getPriceKinds,
    getRequestAttach,
    getRequests, sendMessage, sendNewdogRequest, sendNewdogRequestUpdate
} from "../../api/newdog";
import LoadPanel from "devextreme-react/load-panel";
import ErrorPopup from "../../components/error-popup/error-popup";
import CustomStore from "devextreme/data/custom_store";
import {SelectBox} from "devextreme-react/select-box";
import {Buffer} from "buffer";
import {getddMMyyyyHHmm} from "../../utils/date.utils";
import {TextBox} from "devextreme-react";
import LoadIndicator from "devextreme-react/load-indicator";
import {formatTimestamp, isInnChecksumValid} from "../../utils/string.utils";
import {isAttachForDoc, isDocConditional, isDocMandatory, notAttachedDocs} from "../../utils/newdog-docs.utils";
import ExtFileUploader from "../../components/file-uploader/file-uploader";
import NewdogFiles from "../../components/newdog-files/newdog-files";
import PopSelectCert from "../../components/cryptopro/PopSelectCert";
import {useAuth} from "../../contexts/auth";
import {Popup} from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon"
import {getParamsFromResource} from "../../api/request";
import {Validator as ValidatorDevex, RequiredRule as RequiredRuleValidator} from "devextreme-react/validator";
import Validator from 'devextreme/ui/validator';
let formInstance

const normalizeApiList = (payload) => {
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.data)) return payload.data
    return []
}

/** CheckBox только true/false — без indeterminate (null/undefined). */
const withFormDefaults = (e) => ({
    ...e,
    is_attorney: e.is_attorney === true,
    accepted: e.accepted === true,
    dogovor_type: e.dogovor_type == null || e.dogovor_type === ''
        ? e.dogovor_type
        : String(e.dogovor_type),
})

const isFormValid = (ref) => {
    const result = ref.current?.instance?.validate?.()
    if (!result) return true
    return result.isValid
}

/** Для phone с mask: RequiredRule на пустом поле часто не рисует кружок — считаем по цифрам. */
const isPhoneFilled = (e) => {
    const digits = String(e.value ?? '').replace(/\D/g, '')
    const normalized = digits.length === 11 && digits.startsWith('7') ? digits.slice(1) : digits
    //const test = /^9\d{9}$/.test(normalized)
    //console.log(test)
    return /^9\d{9}$/.test(normalized)
}

const phoneEditorOptions = (extra = {}) => ({
    mask: '+7 (000) 000-0000',
    maskInvalidMessage: 'Некорректный номер телефона',
    ...extra
})

const AddDogovorExtPage = () => {

    //region dogovor
    let formRef = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)]
    const [isUL, setIsUL] = useState(true)
    const [isFL, setIsFL] = useState(true)
    const [isIP, setIsIP] = useState(true)
    //const formRef = new Array(5).fill(useRef(null))
    const [triangle, setTriangle] = useState(false)

    const accordionRef = useRef(null);
    //const inputAddressRef = useRef(null);

    const [selectedTypeDogovor, setSelectedTypeDogovor] = useState()
    const [disabledForms, setDisabledForms] = useState(false)
    const [validateRequired, setValidateRequired] = useState(false)

    const [newdogFiles, setNewdogFiles] = useState(new Map())
    const [notDownloadsAndPreparedState, setNotDownloadsAndPreparedState] = useState(["0"])
    // const {newdogFiles, defaultType} = useReqPopup()
    // const [fileTypes, setFileTypes] =useState([])
    const [loading, setLoading] = useState(false)
    const [messageLoading, setMessageLoading] = useState('Сохраняем...')
    const [reqs, setReqs] = useState([])
    const [selectedReq, setSelectedReq] = useState(() => withFormDefaults({}))
    const [dogKind, setDogKind] = useState([])
    const [consumerTypes, setConsumerTypes] = useState([])
    const [objTypes, setObjTypes] = useState([])
    const [priceKinds, setPriceKinds] = useState([])
    const [docReceiveList, setDocReceiveList] = useState([])
    const [selectedConsumerType, setSelectedConsumerType] = useState(null)
    const [selectedObjType, setSelectedObjType] = useState(null)
    const [dogDocList, setDogDocList] = useState([])

    const [popupErrorVisible, setPopupErrorVisible] = useState(false);
    const [popupErrorText, setPopupErrorText] = useState('');
    const [popupIcon, setPopupIcon] = useState(null);
    const [popupTitle, setPopupTitle] = useState("Ошибка");
    const [popupWidth, setPopupWidth] = useState(500);
    const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null);
    const [onOk, setOnOk] = useState(null);
    const [popupYesNo, setPopupYesNo] = useState(false);
    const onCancel= () => {setPopupErrorVisible(false); setPopupYesNo(false)};
    const onCancelWithOk = () => {setPopupErrorVisible(false); setPopupYesNo(false)};
    const [btnVisibleCancel, setBtnVisibleCancel] = useState(false);
    const [didLoad, setDidLoad] = useState(false);
    const [policyUrl, setPoilicyUrl] = useState('')
    //endregion

    // Преписка по заявке
    const [loadingMessage, setLoadingMessage] = useState(false)
    const [messages, setMessages] = useState([])
    const [visibleAddOldFiles, setVisibleAddOldFiles] = useState(false)
    const [finalDog, setFinalDog] = useState([])
    const { user, selectedDog } = useAuth()
    const messageFormData = useRef({})
    const formMessageRef = useRef()
    const extFileUploaderPerepiskaRef = useRef();
    const [popupFindInnVisible, setPopupFindInnVisible] = useState(false)
    const [popupRefusedVisible, setPopupRefusedVisible] = useState(false)
    const [refusedMessage, setRefusedMessage] = useState('')
    const [finalDogId, setFinalDogId] = useState(null)
    const [nameCompany, setNameCompany] = useState(null)
    const [kppList, setKppList] = useState([])
    const [kpp, setKpp] = useState(null)

    /*    const [loadingInn, setLoadingInn] = useState(false)
        const [checkedInn, setCheckedInn] = useState(null)
        const [labelCheckInn, setLabelCheckInn] = useState(null)
        */

    const onSendRequest = async (validate) => {
        if (validate) {
            setValidateRequired(true)
            const conditionalMissing = await validForms()
            if (!conditionalMissing) {
                return
            }
            // есть такая заявка ранее?
            const equalZayavka = []
            reqs.forEach(e => {
                if (![3,11,4,10].includes[e.id_status] && e.ackt_tehn_num && e.contr_date &&
                    e.dogovor_type !== 2 &&
                    e.ackt_tehn_num === selectedReq.ackt_tehn_num &&
                    e.contr_date === selectedReq.contr_date &&
                    e.id !== selectedReq.id) {
                    equalZayavka.push(e)
                }
            })
            if (equalZayavka.length > 0) {
                notify(`Вы подали заявку № ${equalZayavka[0].ackt_tehn_num} ранее`,'error',5000)
                return
            }
            if (conditionalMissing.length > 0) {
                setNotDownloadsAndPreparedState(conditionalMissing.map(e => e.id))
                showConfirmConditionalDocs(conditionalMissing, async () => {
                    setValidateRequired(false)
                    selectedReq.status = 1
                    await saveRequest()
                })
                return
            }
            setValidateRequired(false)
            selectedReq.status = 1
        } else {
            setValidateRequired(false)
            selectedReq.status = 10
            const equalZayavka = []
            reqs.forEach(e => {
                if (e.ackt_tehn_num && e.contr_date && e.id_status === 10 &&
                    e.ackt_tehn_num === selectedReq.ackt_tehn_num &&
                    e.contr_date === selectedReq.contr_date &&
                    e.id !== selectedReq.id) {
                    equalZayavka.push(e)
                }
            })
            if (equalZayavka.length > 0) {
                await showNotifyDeleteEqualZayavka(equalZayavka)
                return
            }
        }
        await saveRequest()
    }

    const saveRequest = async () => {
        // договор, выбранный в шапке ЛК
        if (selectedDog?.kodDog != null) {
            selectedReq.kod_dog = selectedDog.kodDog
            if (selectedDog.ndog) selectedReq.ndog = selectedDog.ndog
        }
        const fd = new FormData()
        const payload = withFormDefaults(selectedReq)
        Object.entries(payload).forEach(([key, value]) => {
            fd.append(key, value === true || value === false ? String(value) : value)
        })
        await addFiles(fd)
        try {
            setLoading(true)
            await createOrUpdateDogovor(fd)
            //cleanData()
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoading(false)
        }
    }

    // const checkDoubleZayavka = async () =>{
    //
    // }

    const showNotifyDeleteEqualZayavka = async (arrEqualZayavka) =>{
        setPopupErrorText("У вас уже есть сохраненная заявка, перезаписать?")
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Сообщение')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(true)
        setOnOk(() => async () => {
            /*arrEqualZayavka.forEach(async (e) => {
                await deleteDog(e.id)
            });*/
            await deleteDog(arrEqualZayavka[0].id)
            await getListZayavka()
            //setPopupErrorVisible(false)
        })
    }

    const showNotifyDeleteZayavka = async (id) =>{
        setPopupErrorText("Удалить черновик?")
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Внимание')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(true)
        setOnOk(() => async () => {
            const result = await deleteNewDogReq(id)
            if (result.isOk) {
                notify(result.data.message, 'success', 3000)
                await getListZayavka()
                if (accordionRef.current) {
                    const instance = accordionRef.current.instance;
                    // Устанавливаем пустой массив для закрытия всех элементов
                    instance.option('selectedItemKeys', []);
                    instance.expandItem(0)
                }
            } else {
                notify(result.message, 'error', 5000)
            }
            setPopupErrorVisible(false)
        })
    }

    const deleteDog = async(id) =>{
        await showNotifyDeleteZayavka(id)
    }

    const showNotify = async (text, title = 'Ошибка') =>{
        setPopupErrorText(text)
        setPopupIcon(faTriangleExclamation)
        setPopupTitle(title)
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(false)
        setOnOk(() => () => {
            setPopupErrorVisible(false)
        })
    }

    const showConfirmConditionalDocs = (docs, onYes) => {
        const docList = docs.map(doc => '<li>' + doc.nameType + '</li>').join('')
        setPopupErrorText(`Приложены не все обязательные документы:<ol>${docList}</ol>Продолжить?`)
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Внимание')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupYesNo(true)
        setBtnVisibleCancel(true)
        setPopupErrorVisible(true)
        setOnOk(() => async () => {
            setPopupErrorVisible(false)
            setPopupYesNo(false)
            await onYes()
        })
    }

    const saveOneFieldOnBlurFocus = async (key, value) => {
        setValidateRequired(false)
        // false для checkbox — валидное значение; пропускаем только пустые
        if (value === null || value === undefined || value === '') return
        const fd = new FormData()
        fd.append("status","10")
        if (key === 'bic' && value.length > 9) return
        fd.append(key, value === true || value === false ? String(value) : value)
        fd.append('id',selectedReq.id)
        // обновляем в самом массиве
        const newReqs = [...reqs]
        newReqs.map(item => {
            if (item.id === selectedReq.id) {
                item[key] = value
                return item
            } else return item
        })
        setReqs(newReqs)
        setSelectedReq(e => {
            e[key] = value
            return e;
        })
        if (key === 'inn') {
            await validateINN(value)
        }
        //await addFiles(fd);
        try {
            //setLoading(true)
            await createOrUpdateDogovor(fd)
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setValidateRequired(false)
            //setLoading(false)
        }
    }

    const addFiles = async (fd) => {
        //region прикрепляем все файлы к заявке
        if (newdogFiles.size > 0) {
            let docTypes = []
            for (let newDogFile of newdogFiles.keys()) {
                fd.append('document', newdogFiles.get(newDogFile).file)
                docTypes.push(newdogFiles.get(newDogFile).type_id)
            }
            fd.append('doc_types', docTypes)
            newdogFiles.clear();
        }
        //endregion
    }

    const createOrUpdateDogovor = async(fd) =>{
        let result;
        if (fd?.get('id')){
            // проверка на дубли
            // const check = await checkDoubleZayavka()
            // if (check) return
            // update заявки
            result = await sendNewdogRequestUpdate(fd)
            if (result.isOk) {
                // если в заявке есть файлы получаем новый selectedReq чтобы обновилась форма с файлами
                const fdnew = Object.fromEntries(fd)
                if (fdnew.document || +result.status === 1) {
                    await getListZayavka()
                }
                /*((fdnew.inn && fdnew.inn !== selectedReq.inn) && (fdnew.name_company !== selectedReq.name_company || fdnew.kpp !== selectedReq.kpp))) {
                    await getListZayavka()
                }*/
                Object.keys(fdnew).length > 3 && notify(result.message, 'success', 500)
            } else {
                notify(result.message, 'error', 5000)
                return result
            }
        } else {
            // создание заявки id=null только один раз
            result = await sendNewdogRequest(fd)
            if (result.isOk) {
                notify(result.message.message, 'success', 3000)
                await getListZayavka()
            } else {
                notify(result.message, 'error', 5000)
            }
        }
    }

    const getListZayavka = async () => {
        setLoading(true)
        const resGets = await getRequests()
        if (resGets.isOk) {
            const res = resGets.data.map(item => ({
                ...item,
                // Преобразуем в строку, если значение не null/undefined
                dogovor_type: item.dogovor_type != null ? String(item.dogovor_type) : null
            }));
            const requests = normalizeApiList(res).map(withFormDefaults)
            setReqs(requests)
            // проверяем заявку
            if (requests.length > 0 && !selectedReq?.id) {
                setSelectedReq(requests[0])
                setSelectedTypeDogovor(requests[0]?.dogovor_type?.toString())
                setSelectedConsumerType(requests[0]?.consumer_type != null ? String(requests[0].consumer_type) : null)
                setSelectedObjType(requests[0]?.obj_type ?? null)
                setDisabledForms(requests[0].id_status !== 10)
            } else if (requests.length > 0) {
                const obj = requests.find((e) => e.id === selectedReq.id)
                if (obj) {
                    setSelectedReq(obj);
                    setDisabledForms(obj.id_status !== 10)
                    setSelectedTypeDogovor(obj?.dogovor_type?.toString())
                    setSelectedConsumerType(obj?.consumer_type != null ? String(obj.consumer_type) : null)
                    setSelectedObjType(obj?.obj_type ?? null)
                } else {
                    setSelectedReq(requests[0]);
                    setSelectedTypeDogovor(requests[0]?.dogovor_type?.toString())
                    setSelectedConsumerType(requests[0]?.consumer_type != null ? String(requests[0].consumer_type) : null)
                    setSelectedObjType(requests[0]?.obj_type ?? null)
                    setDisabledForms(requests[0].id_status !== 10)
                }
            } else {
                setDisabledForms(true)
            }
        } else {
            notify(resGets.message,'error',10000)
        }
        setLoading(false)
    }

    useEffect(() => {
        (async function(){
            if (!didLoad) {
                await getListZayavka()
                setDidLoad(true);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[didLoad])

    useEffect(() => {
        (async function(){
            //типы заявок
            const resDogKind = await getDogKind()
            if (resDogKind.isOk) setDogKind(normalizeApiList(resDogKind.data))
            const resConsumerTypes = await getConsumerTypes()
            if (resConsumerTypes.isOk) {
                setConsumerTypes(normalizeApiList(resConsumerTypes.data))
            }
            else notify(resConsumerTypes.message, 'error', 5000)
            
            const resObjTypes = await getObjTypes()
            if (resObjTypes.isOk) setObjTypes(normalizeApiList(resObjTypes.data))
            else notify(resObjTypes.message, 'error', 5000)

            const resPriceKinds = await getPriceKinds()
            if (resPriceKinds.isOk) setPriceKinds(normalizeApiList(resPriceKinds.data))
            else notify(resPriceKinds.message, 'error', 5000)

            const resDocReceive = await getDocReceive()
            if (resDocReceive.isOk) setDocReceiveList(normalizeApiList(resDocReceive.data))
            else notify(resDocReceive.message, 'error', 5000)

            const resPolicy = await getParamsFromResource('POLICY_URL')
            if (resPolicy.isOk) setPoilicyUrl(resPolicy.data)
            else notify(resPolicy.message, 'error', 5000)
        })();
    },[])

    useEffect(() => {
        if (!selectedTypeDogovor && !selectedConsumerType && !selectedObjType) return
        let cancelled = false
        ;(async () => {
            const resDocTypes = await getDogDocList({
                dogkind_id: selectedTypeDogovor ?? undefined,
                consumer_type_id: selectedConsumerType ?? undefined,
                obj_type_id: selectedObjType ?? undefined,
            })
            if (cancelled) return
            if (resDocTypes.isOk) {
                setDogDocList(normalizeApiList(resDocTypes.data))
            } else {
                setDogDocList([])
            }
        })()
        return () => { cancelled = true }
    }, [selectedTypeDogovor, selectedConsumerType, selectedObjType])

    /* eslint-disable */
    useEffect(() => {
        (async function(){
            await openAllItems();
            await closeAllItems()
        })();
    },[])
    /* eslint-enable */

    // Функция для открытия всех элементов аккордеона
    const openAllItems = async () => {
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем все индексы как открытые
            formRef.forEach((e,index) => {
                instance.expandItem(index)
            });
        }
    };

    // Функция для закрытия всех элементов аккордеона
    const closeAllItems = async () => {
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем пустой массив для закрытия всех элементов
            instance.option('selectedItemKeys', []);
            instance.expandItem(0)
        }
    };

    // сюда помещаем все очистки форм после отправки (например)
    /*function cleanData() {
        //setNewdogFiles([])
    }*/

    // валидация форм
    const validForms = async () => {

        // boolFormRef === undefined → все формы обнаружены
        let boolFormRef = formRef.find(e => {
            return !e.current
        })

        if (!boolFormRef) {

            // валидируем все формы
            let result = formRef.map(e => {
                return e.current.instance.validate()
            })

            boolFormRef = result.find(e => {
                return !e.isValid
            })

            let messageError = ''
            // закачанные и подготовленные к закачке
            const attachedForCheck = [
                ...(selectedReq.attachments ?? []),
                ...Array.from(newdogFiles).map(e => e[1].type_id),
            ]
            const mandatoryMissing = notAttachedDocs(dogDocList.filter(isDocMandatory), attachedForCheck)
            const conditionalMissing = notAttachedDocs(dogDocList.filter(isDocConditional), attachedForCheck)
            setNotDownloadsAndPreparedState(mandatoryMissing.map(e => e.id))
            mandatoryMissing.forEach(doc => {
                messageError += '<li>Файл: ' + doc.nameType + ' обязателен</li>'
            })

            // [] — всё приложено; непустой — спросить подтверждение отправки
            if (!boolFormRef && messageError === '') {
                return conditionalMissing
            } else {
                conditionalMissing.forEach(doc => {
                    messageError += '<li>Файл: ' + doc.nameType + ' обязателен</li>'
                })
                /*if (!isInnChecksumValid(selectedReq.inn)){
                    messageError += '<li>ИНН не корректный</li>'
                }*/
                result.map(e => {
                    return e.brokenRules.map(rule => {
                        messageError += '<li>' + rule.message + '</li>'
                        return null
                    })
                })
                await showNotify(`<ol>${messageError}</ol>`, 'Отсутствуют сведения и документы')
                //console.log('Невалидные поля:' + result1.brokenRules.map(rule => rule.message).toString());
                return false
            }
        }
    }

    const dateOptions = {
        displayFormat: 'dd.MM.yyyy',
        useMaskBehavior: true,
        openOnFieldClick: true,
    }

    /*const handleFirstNameChange = useCallback((e) => {
        setDaDataQuery(e.value);
        /!*if (autocompleteRef.current) {
            autocompleteRef.current.instance?.validate();
        }*!/

        adjustHeight(); // Корректируем высоту после изменения значения
    }, []);*/

    const clientsStore = new CustomStore({
        key: 'fias_id',
        useDefaultSearch: true,
        load: (loadOptions) => {
            if (loadOptions.filter) {
                //console.log(loadOptions.filter)
                return daDataGet(loadOptions?.filter[0][2], 'address')
                    .then((data) => ({
                        data: data.data.suggestions,
                    }))
                    .catch(() => {
                        throw new Error('Data Loading Error');
                    });
            }
        },
    });

    // address
    const selectionChanged = async (e) => {
        e.selectedItem?.data?.fias_id && await saveOneFieldOnBlurFocus('id_fias', e.selectedItem?.data?.fias_id);
    }

    const bankStore = new CustomStore({
        key: 'bic',
        useDefaultSearch: true,
        load: (loadOptions) => {
            if (loadOptions.filter) {
                //console.log(loadOptions.filter)
                return daDataGet(loadOptions?.filter[0][2], 'bank')
                    .then((response) => {
                        // 2. Безопасно извлекаем массив suggestions (защита от undefined)
                        const suggestions = response?.data?.suggestions || [];
                        // 3. Преобразуем массив: добавляем bic на верхний уровень
                        const mappedData = suggestions.map(item => {
                            return ({
                                ...item,                 // сохраняем все исходные поля (value, unrestricted_value, data и т.д.)
                                bic: item.data?.bic,      // добавляем bic на верхний уровень (опциональная цепочка для безопасности)
                                bicbank: item.data?.bic + ' - ' + item.value,
                            })
                        });
                        // 4. Возвращаем в формате, который ожидает CustomStore
                        return {
                            data: mappedData
                        };
                    })
                    .catch(() => {
                        throw new Error('Data Loading Error');
                    });
            }
        },
    });

    const selectionChangedBank = async (e) => {
        // пишем
        e.selectedItem?.data?.name?.payment && await saveOneFieldOnBlurFocus('bank', e.selectedItem?.data.name.payment);
        e.selectedItem?.data?.bic && await saveOneFieldOnBlurFocus('bic', e.selectedItem?.data?.bic);
        e.selectedItem?.data?.correspondent_account && await saveOneFieldOnBlurFocus('cor_account', e.selectedItem?.data?.correspondent_account);
        // устанавливаем current
        await getListZayavka()
    }

    // select договора
    const onChangeDogovor = async (e) => {
        const selected = reqs.find(item => item.id === e.value)
        if (selected) {
            const normalized = withFormDefaults(selected)
            setSelectedReq(normalized)
            setDisabledForms(normalized.id_status !== 10)
            setSelectedTypeDogovor(normalized?.dogovor_type?.toString())
            setSelectedConsumerType(normalized?.consumer_type != null ? String(normalized.consumer_type) : null)
            setSelectedObjType(normalized?.obj_type ?? null)
            await getFinalDogovorAndRefreshMessage(normalized)
        } else {
            setSelectedReq(withFormDefaults({}))
            setDisabledForms(false)
            setSelectedTypeDogovor(null)
            setSelectedConsumerType(null)
            setSelectedObjType(null)
        }
        setRefusedMessage('')
        messageFormData.current.attachments = []
        messageFormData.current.message = ''
        formMessageRef.current?.instance.getEditor('message').reset()
        extFileUploaderPerepiskaRef?.current?.clearAttachFiles();
    }

    const getFinalDogovorAndRefreshMessage = async (selected) => {
        //получаем финальный договор
        if (!selected?.id || selected.id_status === 10) return
        const resFinalDog = await getFinalDogovor(selected.id)
        if (resFinalDog.isOk) {
            setFinalDog(resFinalDog.data)
        }
        //обновим переписку
        setLoadingMessage(true)
        const resMessages = await getMessages(selected.id)
        if (resMessages.isOk) {
            setMessages(resMessages.data)
        } else notify(resMessages.message, 'error', 10000)
        setLoadingMessage(false)
    }

    const deleteAkt = async (e) => {
        e.preventDefault()
        const idAttach = e.target.id
        setLoading(true)
        const res = await delRequestAttach(idAttach)
        if (res.isOk) {
            notify(res.data.message, 'success', 500)
            await getListZayavka()
        } else notify(res.message, 'error',10000)
        setLoading(false)
    }

    const onSendMessage = async (e) => {
        e.preventDefault()
        const {message, attachments} = messageFormData.current
        //console.log('message',Новое_сообщение, Вложение)
        if (!message) return;
        setLoadingMessage(true)

        const formData = new FormData()
        formData.append('request',selectedReq.id)
        formData.append('message', message)
        if (attachments !== undefined) {
            for (let attach of Array.from(attachments)) {
                formData.append('file', attach)
            }
        }

        const res = await sendMessage(formData)
        if (res.isOk) {
            e.target.reset()
            messageFormData.current = {message: '', attachments: []}
            extFileUploaderPerepiskaRef?.current?.clearAttachFiles();
            getFinalDogovorAndRefreshMessage(selectedReq)
        } else notify(res.message,'error',10000)
        setLoadingMessage(false)
    }

    async function downloadZip(id){
        const resZip = await getDogovorZip(id)
        if (resZip.isOk) {
            let fileDownload = require('js-file-download')
            fileDownload(Buffer.from(resZip.data.zip), resZip.data.zipName)
        }
    }
    async function downloadZipAll(id){
        setLoading(true)
        try {
            const resZip = await getDogovorZipAll(id)
            if (resZip.isOk) {
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(resZip.data.zip), resZip.data.zipName)
            } else {
                notify(resZip.message, 'error', 5000);
            }
        } catch (e) {
            notify(e.message, 'error', 5000);
        } finally {
            setLoading(false)
        }
    }
    // просмотр фала в браузере
    const downloadAsFile = async (idFile)=>{
        const fileToSigned = await getDogovorToSigned(idFile)
        let blob
        if (fileToSigned.data.dogovor.signedFile){
            blob = new Blob([new Uint8Array(fileToSigned.data.dogovor.signedFile.data)], {type: "application/pdf"});
        } else {
            blob = new Blob([new Uint8Array(fileToSigned.data.dogovor.attachment.data)], {type: "application/pdf"});
        }
        const blobUrl = URL.createObjectURL(blob);
        // Открываем в новом окне
        const newWindow = window.open(blobUrl, '_blank');
        // Освобождаем память после загрузки
        if (newWindow) {
            newWindow.onload = () => {
                URL.revokeObjectURL(blobUrl);
            };
        }
    };

    const downloadAkt = async (idAttach, isShowInNewWindow) => {
        setLoading(true)
        const res = await getRequestAttach(idAttach)
        if (res.isOk) {
            if (!isShowInNewWindow) {
                const data = res.data.attachment
                const filename = res.data.filename
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(data), filename)
            } else {
                let blob = new Blob([new Uint8Array(res.data.attachment.data)], {type: "application/pdf"});
                const blobUrl = URL.createObjectURL(blob);
                // Открываем в новом окне
                const newWindow = window.open(blobUrl, '_blank');
                // Освобождаем память после загрузки
                if (newWindow) {
                    newWindow.onload = () => {
                        URL.revokeObjectURL(blobUrl);
                    };
                }
            }
        } else notify(res.message, 'error',10000)
        setLoading(false)
    }

    const onSuccessSign = async () => {
        //получаем финальный договор
        const resFinalDog = await getFinalDogovor(selectedReq.id)
        if (resFinalDog.isOk) {
            setFinalDog(resFinalDog.data)
            notify('Документ успешно подписан!', 'success', 5000)
        }
    }

    const addFileToOldreq = async (type, files) => {
        const fd = new FormData()
        const s_req = selectedReq
        let types = []
        for (let i=0; i<files.length; i++) {
            fd.append('document', files[i])
            types.push(type.id)
        }
        fd.append('types', types)
        fd.append('id_req', s_req.id)
        setLoading(true)
        const resAdd = await addFilesToOldReq(fd)
        if (resAdd.isOk) {
            //обновим список заявок
            await getListZayavka()
            await getFinalDogovorAndRefreshMessage(selectedReq)
            notify(resAdd.message, 'success', 5000)
            //notify(res.message, 'success', 5000)
        } else notify(resAdd.message, 'error', 5000)
        setLoading(false)
    }

    const renderField = (data) => {
        return (
            <TextBox value={data ? `${getddMMyyyyHHmm(data.date_create)} ${data.name_company} - (${data.status})` : ''}
                // defaultValue={data ? `${getddMMyyyyHHmm(data.date_create)} ${data.name_company} - (${data.status})` : ''}
            />
        );
    }

    const saveFilesToDraft = async (filesMap) => {
        if (!selectedReq?.id || !filesMap?.size) return false
        const fd = new FormData()
        fd.append('status', '10')
        fd.append('id', selectedReq.id)
        const docTypes = []
        for (const entry of filesMap.values()) {
            fd.append('document', entry.file)
            docTypes.push(entry.type_id)
        }
        fd.append('doc_types', docTypes)
        try {
            setLoading(true)
            const result = await createOrUpdateDogovor(fd)
            return !(result && result.isOk === false)
        } catch (e) {
            notify(e.message, 'error', 5000)
            return false
        } finally {
            setLoading(false)
        }
    }

    const onValueChanged = async (files, index, obj) => {
        const toSave = new Map()
        if (files.length > 0) {
            files.forEach(e => {
                if (!e.delfiles) {
                    toSave.set(index + '' + obj.id + e.name, {
                        id: toSave.size + 1000000,
                        type_name: obj.nameType,
                        type_id: obj.id,
                        file_name: e.name,
                        file: e,
                        index: index
                    })
                }
            })
        }

        if (!toSave.size) return

        const ok = await saveFilesToDraft(toSave)
        if (!ok) {
            // оставляем в памяти — уйдут по «Сохранить черновик»
            setNewdogFiles(prev => {
                const next = new Map(prev)
                toSave.forEach((v, k) => next.set(k, v))
                return next
            })
        }
    }

    const newDogovor = async () => {
        if (!dogKind?.length) {
            notify('Список типов заявок ещё не загружен', 'error', 5000)
            return
        }

        const appendIf = (key, value) => {
            if (value === null || value === undefined || value === '') return
            fd.append(key, value)
        }

        const dog = selectedDog || {}
        const inn = user?.inn || dog.inn || ''
        // Без договора имени нет — '' обязателен: в as_newdog_req name_company NOT NULL
        const nameCompany = dog.name || ''
        const kpp = dog.kpp || ''
        // 10 цифр + КПП → ЮЛ; иначе тип выбирает пользователь
        const consumerType = (String(inn).length === 10 && kpp) ? '1' : null

        const fd = new FormData()
        fd.append('status', '10')
        fd.append('is_attorney', false)
        fd.append('dogovor_type', String(dogKind[0].id))
        fd.append('name_company', nameCompany)
        setSelectedTypeDogovor(String(dogKind[0].id))

        appendIf('inn', inn)
        appendIf('kpp', kpp)
        appendIf('ogrn', dog.ogrn)
        appendIf('okpo', dog.okpo)
        appendIf('okved', dog.okved)
        appendIf('legal_address', dog.adrUr)
        appendIf('postal_address', dog.adrDP || dog.adrD)
        appendIf('fio', dog.fioDir)
        appendIf('email', dog.emailDog || user?.email)
        appendIf('phone', user?.mobilePhone)
        appendIf('consumer_type', consumerType)
        appendIf('kod_dog', dog.kodDog)
        appendIf('ndog', dog.ndog)

        if (consumerType) {
            setSelectedConsumerType(consumerType)
        }

        // Kontur только если есть валидный по длине ИНН и нет наименования с договора
        if (inn && !nameCompany && isInnReadyForBackendCheck(inn)) {
            selectedReq.inn = inn
            await validateINN(inn)
        }

        createOrUpdateDogovor(fd).then();
        selectedReq.attachments = []
        selectedReq.id = null
        setValidateRequired(false)
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем пустой массив для закрытия всех элементов
            instance.option('selectedItemKeys', []);
            instance.expandItem(0)
        }
    }

    //проверяем инн по апи и заполняем поля
    const validateINN = async (inn) => {
        const innStr = String(inn ?? '').trim()
        if (!isInnReadyForBackendCheck(innStr)) {
            return
        }

        try {
            setMessageLoading('Проверяем ИНН...')
            const res = await checkINN(innStr)
            if (!res.isOk) {
                //notify(res.message || 'Ошибка при проверке ИНН!', 'error', 5000)
                console.log(res.message || 'Ошибка при проверке ИНН!')
                return
            }
            if (res.localOnly) {
                return
            }
            const parsedData = await parseKonturRes(res.data)
            if (parsedData) {
                setNameCompany(parsedData.name)
                setKppList(parsedData.listKpp)
                setKpp(parsedData.listKpp[0])
                setPopupFindInnVisible(true)
            }
        } finally {
            setMessageLoading('Сохраняем...')
        }
    }

    async function parseKonturRes(json) {
        if (json.length === 0) return null
        const companyUl = json[0].UL
        const nameCompany = companyUl.legalName.full
        const branches = companyUl.branches
        let listKpp = [companyUl.kpp]
        if (branches) {
            for (let i = 0; i < branches.length; i++) {
                listKpp.push(branches[i].kpp)
            }
        }
        return {name: nameCompany, listKpp: listKpp}
        //return {name: 'Название компании из ИНН', listKpp: ['123456789','987654321']}
    }



    const changeKPP = useCallback((e) => {
            setKpp(e.value);
        },[setKpp],
    );

    const hidePop = () => {
        setPopupFindInnVisible(false)
    }

    const hidePopRefused = () => {
        setRefusedMessage('')
        setPopupRefusedVisible(false)
    }

    const onFormSubmitRefused = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const res = await clientSignRefused(selectedReq.id, finalDogId, refusedMessage)
            if (res.isOk) {
                await getFinalDogovorAndRefreshMessage(selectedReq)
                setRefusedMessage(null)
                notify(res.message, 'success', 5000)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoading(false)
            hidePopRefused();
        }

    }

    /*const onInitialized = (e) => {
        formInstance = e.component;
    }*/

    const dictSelectOptions = (dataSource, extra = {}) => ({
        dataSource,
        displayExpr: (item) => item?.name ?? item?.nameType ?? '',
        valueExpr: 'id',
        searchEnabled: true,
        showClearButton: true,
        ...extra
    })

    useEffect(() => {
        (async function(){
            const consumerTypeId = String(selectedConsumerType ?? selectedReq?.consumer_type ?? '')
            //без таймаута не инициализируется валидация в первом аккордеоне
            setTimeout(async () => {
                setIsUL(consumerTypeId === '1')
                setIsFL(consumerTypeId === '2')
                setIsIP(consumerTypeId === '3')
            }, 100);
        })();
    },[selectedConsumerType, selectedReq?.consumer_type])

    return (
        <div className={'content-block dx-card responsive-paddings add-dogovor-ext'}>
            <>
                <LoadPanel message={messageLoading} visible={loading} />
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                <h3><strong>Заключить договор{/*<ZagolovokFromMenu/>*/}</strong></h3>
                <SelectBox labelMode={'outside'}
                           label={'Мои заявки'} className="big-input mt-4"
                           noDataText="Нет заявок для отображения"
                           placeholder="Выберите заявку.."
                           dataSource={reqs}
                           displayExpr="name_company"
                           valueExpr="id"
                           value={selectedReq ? selectedReq.id : null}
                           onValueChanged={(e) => {
                               setValidateRequired(false)
                               onChangeDogovor(e);
                           }}
                           searchEnabled={true}
                           itemRender={(e) => <div><span className='small'>{getddMMyyyyHHmm(e.date_create)}</span> {e.name_company} - ({e.status})</div>}
                           fieldRender={renderField}

                >
                </SelectBox>
                <Accordion
                    ref={accordionRef}
                    className={'mt-4 add-dogovor-tat validationMessage'}
                    animationDuration={300}
                    id="accordion-container"
                    multiple={true}
                    collapsible={true}
                    triangle={triangle}
                >
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px', display: isFormValid(formRef[0]) || !validateRequired ? 'none':'inline'}} className="dx-icon-warning"></i>
                            <span>Общие сведения</span>
                        </div>
                    )}>
                        <form className="" >
                            <Form
                                disabled={disabledForms}
                                ref={formRef[0]}
                                formData={selectedReq}
                                id="dogovor-form1"
                                labelMode= "floating"
                                labelLocation="left"
                                onFieldDataChanged={ (e) => {
                                    setTriangle(isFormValid(formRef[0]));
                                    /*if (e.dataField === 'consumer_type') {
                                        setSelectedConsumerType(e.value != null ? String(e.value) : null)
                                    }*/
                                    if (e.dataField === 'dogovor_type') {
                                        setSelectedTypeDogovor(e.value ?? null)
                                    }
                                    if (e.dataField === 'consumer_type') {
                                        setSelectedConsumerType(e.value ?? null)
                                    }
                                    saveOneFieldOnBlurFocus(e.dataField, e.value)

                                }
                                }
                                //onInitialized={onInitialized}
                            >
                                <GroupItem colCount={3}>
                                {/*<Item editorType={'dxSelectBox'} dataField={'consumer_type'} editorOptions={{
                                    noDataText: "Нет данных для отображения",
                                    placeholder: "Тип потребителя",
                                    dataSource: consumerTypes,
                                    displayExpr: "name",
                                    valueExpr: "id",
                                    defaultValue: selectedConsumerType,
                                    value: selectedConsumerType,
                                    onValueChanged: function(e) {
                                        if (!e.value || String(e.value) === String(selectedConsumerType)) return
                                        setTimeout(() => setSelectedConsumerType(e.value.toString()), 0)
                                    }
                                }} >
                                    <Label text={'Тип потребителя'} />
                                    {validateRequired && <RequiredRule message="Тип потребителя обязателен" />}
                                </Item>*/}
                                    <Item editorType={'dxSelectBox'} dataField={'consumer_type'} editorOptions={dictSelectOptions(consumerTypes, {validationMessagePosition:"bottom",})}>
                                        <Label text={'Тип потребителя'} />
                                        {validateRequired && <RequiredRule message="Тип потребителя обязателен" />}
                                    </Item>
                                <Item dataField="name_company" editorType="dxTextBox" editorOptions={{autoResizeEnabled:true, minHeight:35}}>
                                    <Label text={"Наименование потребителя"}/>
                                    <StringLengthRule max={500} message="Наименование потребителя максимум 500 символов" />
                                    <PatternRule pattern=".{3,500}" message="Наименование потребителя минимум 3 символа" />
                                    {validateRequired && <RequiredRule message="Наименование потребителя обязательно"/>}
                                </Item>
                                {/*<Item editorType={'dxSelectBox'} dataField={'dogovor_type'} editorOptions={{
                                    noDataText: "Нет данных для отображения",
                                    placeholder: "Тип заявки",
                                    dataSource: dogKind,
                                    displayExpr: "name",
                                    valueExpr: "id",
                                    defaultValue: selectedTypeDogovor,
                                    value: selectedTypeDogovor,
                                    onValueChanged: function(e) {
                                        //e.value && setSelectedTypeDogovor(e.value.toString())
                                        if (!e.value || String(e.value) === String(selectedTypeDogovor)) return
                                        setTimeout(() => setSelectedTypeDogovor(e.value.toString()), 0)
                                        if (e.dataField === 'dogovor_type') {
                                            setSelectedTypeDogovor(e.value ?? null)
                                        }
                                    }

                                }} >
                                    <Label text={'Тип заявки'} />
                                    {validateRequired && <RequiredRule message="Тип заявки обязателен" />}
                                </Item>*/}
                                    <Item editorType={'dxSelectBox'} dataField={'dogovor_type'} editorOptions={dictSelectOptions(dogKind, {validationMessagePosition:"bottom",})}>
                                        <Label text={'Тип заявки'} />
                                        {validateRequired && <RequiredRule message="Тип заявки обязателен" />}
                                    </Item>
                                <Item dataField="inn" editorType="dxTextBox" editorOptions={{
                                    inputAttr: { maxLength: 12, pattern: '\\d*' },
                                    format: '#',
                                    onInput: (e) => {
                                        const val = e.event.target.value.replace(/\D/g, '').slice(0,12);
                                        e.event.target.value = val;
                                        const editor = formInstance?.getEditor('inn');
                                        if (editor) {
                                            const instance = Validator.getInstance(editor.element());
                                            const length = val?.toString().length
                                            instance.isValid = (length !== 10 && length !== 12) && isInnChecksumValid(val);
                                            editor.element().focus();
                                        }
                                    }
                                }}>
                                    <Label text={"ИНН"} />
                                    {validateRequired && <CustomRule
                                        message="Неверная контрольная сумма ИНН."
                                        validationCallback={(e) => isInnChecksumValid(e.value)}
                                        reevaluate={true}
                                    />}
                                    {validateRequired && <RequiredRule message="Поле ИНН обязательно. 10 или 12 цифр" />}
                                    <PatternRule pattern="^\d{10}(\d{2})?$" message="Поле ИНН 10 или 12 цифр!" />
                                </Item>
                                <Item visible={isUL} dataField="kpp" editorType="dxTextBox" editorOptions={{
                                    inputAttr: { maxLength: 9, pattern: '\\d*' },
                                    format: '#',
                                    valueChangeEvent:"blur",
                                    onInput: (e) => {
                                        e.event.target.value = e.event.target.value.replace(/\D/g, '').slice(0,9);
                                    }
                                }}>
                                    <Label text={"КПП"} />
                                    {validateRequired && <RequiredRule message="Поле КПП обязательно! 9 цифр"/>}
                                    <PatternRule pattern="^\d{9}$" message="Поле КПП 9 цифр!" />
                                </Item>
                                <Item visible={isUL} dataField="ogrn" editorType="dxTextBox" editorOptions={{
                                    inputAttr: { maxLength: 13, pattern: '\\d*' },
                                    onInput: (e) => { e.event.target.value = e.event.target.value.replace(/\D/g, '').slice(0,13); }
                                }}>
                                    <Label text={"ОГРН"} />
                                    {validateRequired && <RequiredRule message="ОГРН обязателен" />}
                                    <PatternRule pattern="^\d{13}$" message="ОГРН должен содержать 13 цифр" />
                                </Item>
                                <Item visible={isUL} dataField="okpo" editorType="dxTextBox">
                                    <Label text={"ОКПО"} />
                                    {validateRequired && <RequiredRule message="ОКПО обязателен" />}
                                    <PatternRule pattern="^\d{8}(\d{2})?$" message="ОКПО 8 или 10 цифр" />
                                </Item>
                                <Item visible={isIP || isUL} dataField="okved" editorType="dxTextBox">
                                    <Label text={"ОКВЭД"} />
                                    {validateRequired && <RequiredRule message="ОКВЭД обязателен" />}
                                    <StringLengthRule max={20} message="ОКВЭД максимум 20 символов" />
                                </Item>
                                <Item visible={isIP} dataField="ogrip" editorType="dxTextBox" editorOptions={{
                                    inputAttr: { maxLength: 15, pattern: '\\d*' },
                                    onInput: (e) => { e.event.target.value = e.event.target.value.replace(/\D/g, '').slice(0,15); }
                                }}>
                                    <Label text={"ОГРИП"} />
                                    {validateRequired && <RequiredRule message="ОГРИП обязателен" />}
                                    <PatternRule pattern="^\d{15}$" message="ОГРИП должен содержать 15 цифр" />
                                </Item>
                                <Item visible={isFL} dataField="snils" editorType="dxTextBox" editorOptions={{
                                    mask: '000-000-000 00',
                                }}>
                                    <Label text={"СНИЛС"} />
                                    {isFL && validateRequired && <RequiredRule message="СНИЛС обязателен" />}
                                </Item>
                                <Item visible={isFL || isIP} dataField="passport_num" editorType="dxTextBox">
                                    <Label text={"Серия и номер паспорта"} />
                                    {validateRequired && <RequiredRule message="Серия и номер паспорта обязательны" />}
                                   <StringLengthRule max={20} message="Серия и номер паспорта максимум 20 символов" />
                                </Item>
                                <Item visible={isFL || isIP} dataField="passport_date" editorType="dxDateBox" editorOptions={dateOptions}>
                                    <Label text={"Дата выдачи паспорта"} />
                                    {validateRequired && <RequiredRule message="Дата выдачи паспорта обязательна" />}
                                </Item>
                                <Item
                                    dataField="legal_address"
                                    editorType="dxAutocomplete"
                                    editorOptions={{
                                        showClearButton: true,
                                        dataSource: clientsStore,
                                        valueExpr: "unrestricted_value",
                                        placeholder: "Начните вводить адрес...",
                                        minSearchLength: 1,
                                        searchTimeout: 300,
                                        valueChangeEvent:"blur"
                                    }}
                                >
                                    <Label text="Юридический адрес" />
                                    {validateRequired && <RequiredRule message="Юридический адрес обязателен" />}
                                </Item>
                                <Item
                                    dataField="postal_address"
                                    editorType="dxAutocomplete"
                                    editorOptions={{
                                        showClearButton: true,
                                        dataSource: clientsStore,
                                        valueExpr: "unrestricted_value",
                                        placeholder: "Начните вводить адрес...",
                                        minSearchLength: 1,
                                        searchTimeout: 300,
                                        valueChangeEvent:"blur"
                                    }}
                                >
                                    <Label text="Почтовый адрес" />
                                    {validateRequired && <RequiredRule message="Почтовый адрес обязателен" />}
                                </Item>
                                <Item dataField="fio" editorType="dxTextBox">
                                    <Label text={"Контактное лицо по заявлению (ФИО)"}/>
                                    {validateRequired && <RequiredRule message="Контактное лицо обязательно" />}
                                    <StringLengthRule max={250} message="Максимум 250 символов" />
                                </Item>
                                <Item dataField="phone" editorType="dxTextBox" editorOptions={phoneEditorOptions({
                                    valueChangeEvent:"blur"
                                })}>
                                    <Label text={"Контактный телефон"} />
                                    {validateRequired && <CustomRule
                                        message="Контактный телефон обязателен"
                                        reevaluate={true}
                                        validationCallback={(e) => isPhoneFilled(e)}
                                    />}
                                </Item>
                                <Item dataField="email" editorType="dxTextBox">
                                    <Label text={"Электронная почта"} />
                                    {validateRequired && <RequiredRule message="Электронная почта обязательна" />}
                                    <EmailRule message="Неверный формат email" />
                                </Item>
                                <Item editorType={'dxSelectBox'} dataField={'doc_receive'} editorOptions={dictSelectOptions(docReceiveList)}>
                                    <Label text={'Способ получения договора'} />
                                    {validateRequired && <RequiredRule message="Способ получения договора обязателен" />}
                                </Item>
                                <Item colSpan={3} dataField="is_attorney" editorType="dxCheckBox" editorOptions={{
                                    text: 'Являюсь представителем заявителя по доверенности',
                                    enableThreeStateBehavior: false,
                                    onValueChanged: (e) => {
                                        setSelectedReq((prev) => ({
                                            ...prev,
                                            is_attorney: e.value === true,
                                        }))
                                    },
                                }}>
                                    <Label visible={false} />
                                </Item>
                                {selectedReq?.is_attorney && (
                                    <Item colSpan={3}>
                                        <div className="text-muted" style={{ fontSize: '13px', lineHeight: 1.4, marginTop: '-4px' }}>
                                            Если договор подписывает доверенное лицо, в «Документах к заявке» прикрепите
                                            документ, подтверждающий полномочия лица на подписание договора от имени заявителя.
                                        </div>
                                    </Item>
                                )}
                                </GroupItem>
                            </Form>
                        </form>
                    </AccItem>
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px', display: isFormValid(formRef[1]) || !validateRequired ? 'none':'inline'}} className="dx-icon-warning"></i>
                            <span>Описание объектов энергоснабжения</span>
                        </div>
                    )}>
                        <form className="">
                            <Form disabled={disabledForms}
                                  ref={formRef[1]}
                                  formData={selectedReq}
                                  id="dogovor-form2"
                                  colCount={2}
                                  labelMode= "floating"
                                  labelLocation="left"
                                  onFieldDataChanged={ (e) => {
                                      setTriangle(isFormValid(formRef[1]));
                                      if (e.dataField === 'obj_type') {
                                          setSelectedObjType(e.value ?? null)
                                      }
                                      saveOneFieldOnBlurFocus(e.dataField, e.value)
                                  }
                                  }
                            >
                                <Item editorType={'dxSelectBox'} dataField={'obj_type'} editorOptions={dictSelectOptions(objTypes, {validationMessagePosition:"bottom",})}>
                                    <Label text={'Тип объекта энергоснабжения'} />
                                    {validateRequired && <RequiredRule message="Тип объекта энергоснабжения обязателен" />}
                                </Item>
                                <Item editorType={'dxSelectBox'} dataField={'price_kind'} editorOptions={dictSelectOptions(priceKinds)}>
                                    <Label text={'Вид цены для расчета'} />
                                    {validateRequired && <RequiredRule message="Вид цены для расчета обязателен" />}
                                </Item>
                                <Item
                                    dataField="adress"
                                    colSpan={2}
                                    editorType="dxAutocomplete"
                                    editorOptions={{
                                        showClearButton: true,
                                        dataSource: clientsStore,
                                        valueExpr: "unrestricted_value",
                                        placeholder: "Начните вводить адрес...",
                                        minSearchLength: 1,
                                        searchTimeout: 300,
                                        valueChangeEvent:"blur",
                                        validationMessagePosition:"bottom",
                                        onSelectionChanged: selectionChanged,
                                    }}
                                >
                                    <Label text="Адрес объекта" />
                                    {validateRequired && <RequiredRule message="Адрес объекта обязателен" />}
                                </Item>
                            </Form>
                        </form>
                    </AccItem>
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px', display: isFormValid(formRef[2]) || !validateRequired ? 'none':'inline'}} className="dx-icon-warning"></i>
                            <span>Банковские реквизиты</span>
                        </div>
                    )}>
                        <form className="">
                            <Form disabled={disabledForms}
                                  ref={formRef[2]}
                                  formData={selectedReq}
                                  id="dogovor-form3"
                                  colCount={2}
                                  labelMode= "floating"
                                  labelLocation="left"
                                  onFieldDataChanged={ (e) => {
                                      setTriangle(isFormValid(formRef[2]));
                                      saveOneFieldOnBlurFocus(e.dataField, e.value)
                                  }
                                  }

                            >
                                <Item
                                    dataField="bank"
                                    editorType="dxAutocomplete"
                                    editorOptions={{
                                        showClearButton: true,
                                        dataSource: bankStore,
                                        valueExpr: "unrestricted_value",
                                        placeholder: "Начните вводить название банка или бик...",
                                        minSearchLength: 1,
                                        searchTimeout: 300,
                                        valueChangeEvent:"blur",
                                        validationMessagePosition:"bottom",
                                        onSelectionChanged: selectionChangedBank,
                                    }}
                                >
                                    <Label text="Банк" />
                                    {validateRequired &&
                                        <RequiredRule message="Банк обязателен" />
                                    }
                                </Item>
                                <Item dataField="bic" editorType="dxAutocomplete" editorOptions={
                                    {
                                        inputAttr: { maxLength: 9, pattern: '\\d*' },
                                        format: '#',
                                        valueChangeEvent:"blur",
                                        showClearButton: true,
                                        dataSource: bankStore,
                                        valueExpr: "bicbank",
                                        placeholder: "Начните вводить бик...",
                                        minSearchLength: 1,
                                        validationMessagePosition:"bottom",
                                        onSelectionChanged: selectionChangedBank,
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        }
                                    }
                                }>

                                    <Label text={"БИК"} />
                                    {validateRequired &&
                                        <RequiredRule message="БИК обязателен" />
                                    }
                                    <StringLengthRule max={9} message="Бик должен содержать ровно 9 цифр" />
                                    <PatternRule pattern="^\d{9}$" message="БИК должен содержать ровно 9 цифр" />
                                </Item>
                                <Item dataField="cor_account" editorType="dxTextBox" editorOptions={{
                                    inputAttr: { maxLength: 20, pattern: '\\d*' }, // Ограничение длины ввода до 20 символов
                                    format: '#',
                                    onInput: (e) => {
                                        // Оставляем только цифры в поле ввода
                                        e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                    },
                                    validationMessagePosition:"top",
                                }}>
                                    <Label text={"Корр.счет"} />
                                    {validateRequired &&
                                        <RequiredRule message="Корр.счет обязателен" />
                                    }
                                    <StringLengthRule max={20} message="Корр.счет должен содержать ровно 20 цифр" />
                                    <PatternRule pattern="^\d{20}$" message="Корр.счет должен содержать ровно 20 цифр" />
                                </Item>
                                <Item dataField="pay_account" editorType="dxTextBox" editorOptions={{
                                    inputAttr: { maxLength: 20, pattern: '\\d*' },// Ограничение длины ввода до 20 символов
                                    validationMessagePosition:"top",
                                    format: '#',
                                    onInput: (e) => {
                                        // Оставляем только цифры в поле ввода
                                        e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                    },
                                }}
                                >
                                    <Label text={"Расчетный счет"} />
                                    {validateRequired &&
                                        <RequiredRule message="Расчетный счет обязателен" />
                                    }
                                    <StringLengthRule max={20} message={`Расчетный счет должен содержать ровно 20 цифр`} />
                                    <PatternRule pattern="^\d{20}$" message="Расчетный счет должен содержать ровно 20 цифр" />
                                </Item>
                            </Form>
                        </form>
                    </AccItem>
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px',
                                display: (validateRequired && notDownloadsAndPreparedState.length > 0) ? 'inline':'none'}} className="dx-icon-warning"></i>
                            <span>Документы к заявке</span>
                        </div>
                    )}>
                        <Form
                            ref={formRef[3]}
                            id="dogovor-form4"
                            colCount={1}
                            labelMode= "hidden"
                            className='popupWithUploader'
                        >
                            {
                                selectedReq &&
                                ![10].includes(selectedReq.id_status) &&
                                <GroupItem>
                                    <Item>
                                        <ol className='round-button-only-icon'>
                                            {
                                                selectedReq?.attachments?.map(file =>
                                                    <li className='mb-1' key={file.id}>
                                                        <Button className='mr-3' hint='Скачать' type='default' icon='download' onClick={ async () => await downloadAkt(file.id, false)}></Button>
                                                        {/*<Button className='mr-1' icon='eyeopen' hint='Открыть в новой вкладке' type='default' onClick={ async () => downloadAkt(file.id, true)}></Button>{file.name_type}:
                                                        {file.filename}*/}
                                                        {file.name_type}: <a className="dashed" id="link1" href='/' onClick={async (e) => {e.preventDefault(); await downloadAkt(file.id, true); }}>{file.filename}</a>
                                                    </li>)
                                            }
                                        </ol>
                                        <Button className="" text="Добавить документы" icon="add" onClick={()=>{setVisibleAddOldFiles(true)}}/>
                                        {/*maxLengthFileName - сработает только для ТЭС*/}
                                        <NewdogFiles typeFileLimit={'newdog'} maxLengthFileName={124} visible={visibleAddOldFiles} types={dogDocList} onClose={() => setVisibleAddOldFiles(false)} onAddFiles={addFileToOldreq}/>
                                    </Item>
                                </GroupItem>
                            }
                            {
                                selectedReq &&
                                selectedReq.id_status === 10 &&
                                dogDocList &&
                                [...dogDocList].sort((a, b) => +a.fillOrder - +b.fillOrder).map((obj, index) => {
                                    const rowKey = String(obj.id)
                                    const slotAttaches = (selectedReq?.attachments ?? []).filter(e => isAttachForDoc(e, obj))
                                    return (
                                    <GroupItem key={rowKey}>
                                        <Item>
                                            <div className={'row'}>
                                                <div className='col-md-6 mb-3'>
                                                    <i style={{ fontSize: '16px', color: 'red',marginRight: '10px',
                                                        display: (validateRequired && notDownloadsAndPreparedState.length > 0 && +obj.needUse !== 10 && notDownloadsAndPreparedState.includes(obj.id)) ? 'inline':'none'}} className="dx-icon-warning"></i>
                                                    <span className={'nameType mb-1'}>{(isDocMandatory(obj) || isDocConditional(obj)) && <span title={'Обязательный документ'} className={'text-danger'}>✱</span>} {index+1}. {obj.nameType}</span><br/>
                                                    <small>{obj.info}</small><br/>
                                                    <ul>
                                                        {slotAttaches.map((e) =>
                                                            <li key={e.id}><a href={'/'} onClick={async (ev) => { ev.preventDefault(); await downloadAkt(e.id, false) }} id={e.id}>{e.filename}</a>
                                                                &nbsp;&nbsp;—&nbsp;&nbsp;
                                                                <a href={'/'} onClick={deleteAkt} id={e.id}>Удалить</a><br/></li>
                                                        )}
                                                    </ul>
                                                </div>
                                                <div className='col-md-6'>
                                                    {/*maxLengthFileName - сработает только для ТЭС*/}
                                                    <ExtFileUploader
                                                        key={`${selectedReq.id}-${rowKey}-${slotAttaches.length}`}
                                                        maxLengthFileName={120}
                                                        selectedReqId={selectedReq.id ?? null}
                                                        disabledForms={disabledForms}
                                                        typeFileLimit={'newdog'}
                                                        setfile={(e) => onValueChanged(e, index, obj)}
                                                    />
                                                </div>
                                            </div>
                                            <hr/>
                                        </Item>
                                    </GroupItem>
                                    )
                                })
                            }
                        </Form>
                    </AccItem>
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{
                                fontSize: '16px',
                                color: 'red',
                                marginRight: '10px',
                                display: isFormValid(formRef[4]) || !validateRequired ? 'none' : 'inline'
                            }} className="dx-icon-warning"></i>
                            <span>Дополнительная информация</span>
                        </div>
                    )}>
                        <form className="">
                            <Form
                                disabled={disabledForms}
                                ref={formRef[4]}
                                formData={selectedReq}
                                id="dogovor-form5"
                                labelMode="floating"
                                labelLocation="top"
                                onFieldDataChanged={(e) => {
                                    setTriangle(isFormValid(formRef[4]))
                                    saveOneFieldOnBlurFocus(e.dataField, e.value)
                                }
                                }
                            >
                                <GroupItem>
                                    <h4 className="form-subtitle">Сведения об ответственных лицах заявителя.</h4>
                                </GroupItem>

                                <GroupItem>
                                    <h5 className="form-subtitle">Контакты для направления уведомлений о введении ограничения режима потребления электрической энергии:</h5>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <Item dataField="notify_phone" editorType="dxTextBox" editorOptions={phoneEditorOptions()}>
                                        <Label text={"Мобильный телефон"} />
                                        {validateRequired && <CustomRule
                                            message="Мобильный телефон обязателен"
                                            reevaluate={true}
                                            validationCallback={(e) => isPhoneFilled(e)}
                                        />}
                                    </Item>
                                    <Item dataField="notify_email" editorType="dxTextBox" editorOptions={{
                                        mode: 'email',
                                    }}>
                                        <Label text={"Email"} />
                                        {validateRequired && <RequiredRule message="Email обязателен" />}
                                        <EmailRule message="Неверный формат email" />
                                    </Item>
                                </GroupItem>

                                <GroupItem>
                                    <h5 className="form-subtitle">Лицо, ответственное за исполнение договора энергоснабжения:</h5>
                                    <div>
                                        обеспечение сохранности прибора учета и систем учета;<br/>
                                        предоставление доступа к месту установки прибора учета;<br/>
                                        снятие и представление показаний прибора учета, в т.ч. акта снятия показаний прибора учета;
                                    </div>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="resp_pu_fio" editorType="dxTextBox" editorOptions={{valueChangeEvent: "keyup"}}>
                                        <Label text={"Ф.И.О."} />
                                        {validateRequired && <RequiredRule message="Ф.И.О. обязательно" />}
                                    </Item>
                                    <Item dataField="resp_pu_phone" editorType="dxTextBox" editorOptions={phoneEditorOptions()}>
                                        <Label text={"Телефон"} />
                                        {validateRequired && <CustomRule
                                            message="Телефон обязателен"
                                            reevaluate={true}
                                            validationCallback={(e) => isPhoneFilled(e)}
                                        />}
                                    </Item>
                                    <Item dataField="resp_pu_email" editorType="dxTextBox" editorOptions={{
                                        mode: 'email',
                                    }}>
                                        <Label text={"Email"} />
                                        {validateRequired && <RequiredRule message="Email обязателен" />}
                                        <EmailRule message="Неверный формат email" />
                                    </Item>
                                </GroupItem>

                                <GroupItem>
                                    <h5 className="form-subtitle">Лицо, ответственное за взаиморасчеты и получение счетов на оплату:</h5>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="resp_pay_fio" editorType="dxTextBox" editorOptions={{
                                        validationMessagePosition:"top"
                                    }}>
                                        <Label text={"Ф.И.О."} />
                                        {validateRequired && <RequiredRule message="Ф.И.О. обязательно" />}
                                    </Item>
                                    <Item dataField="resp_pay_phone" editorType="dxTextBox" editorOptions={phoneEditorOptions({
                                        validationMessagePosition:"top"
                                    })}>
                                        <Label text={"Телефон"} />
                                        {validateRequired && <CustomRule
                                            message="Телефон обязателен"
                                            reevaluate={true}
                                            validationCallback={(e) => isPhoneFilled(e)}
                                        />}
                                    </Item>
                                    <Item dataField="resp_pay_email" editorType="dxTextBox" editorOptions={{
                                        mode: 'email',
                                        validationMessagePosition:"top"
                                    }}>
                                        <Label text={"Email"} />
                                        {validateRequired && <RequiredRule message="Email обязателен" />}
                                        <EmailRule message="Неверный формат email" />
                                    </Item>
                                </GroupItem>
                            </Form>
                        </form>
                    </AccItem>
                </Accordion>
                <div className='agreement-row mt-4'>
                <form  className="agreement-wrapper">
                    <Form
                        className="mt-4"
                        visible={!disabledForms}
                        ref={formRef[5]}
                        formData={selectedReq}
                        id="dogovor-form5"
                        colCount={1}
                        labelMode= "floating"
                        labelLocation="left"
                    >
                        <Item dataField="accepted"
                              editorType="dxCheckBox"
                              editorOptions={{
                                  enableThreeStateBehavior: false,
                              }}>
                            <Label visible={false} />
                            <CompareRule message="Необходимо принять условия обработки данных"
                                         comparisonTarget={() => true}
                            />
                        </Item>
                    </Form>
                </form>
                {!disabledForms &&
                    <span className='check-box-tatenergo'>Принимаю <a href={policyUrl} target="_blank" rel="noopener noreferrer">условия обработки данных</a></span>
                }
                </div>
                <div className='row mb-5'>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="plus" type={'default'} text="Новая заявка" hint="Новая заявка" onClick={newDogovor}/></div>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="edit" disabled={disabledForms} type={'default'} text="Сохранить черновик" hint="Сохранить черновик" onClick={() => onSendRequest(false)}/></div>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="trash" disabled={disabledForms} type={'default'} text="Удалить черновик" hint="Удалить черновик" onClick={async () => {
                        await deleteDog(selectedReq.id);
                    }}/></div>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="email" disabled={disabledForms} type={'default'} text="Отправить заявку" hint="Отправить заявку" onClick={() => onSendRequest(true)}/></div>
                </div>
                <ErrorPopup text={popupErrorText}
                            icon = {popupIcon}
                            width={popupWidth}
                            title ={popupTitle}
                            btnVisible={true}
                            visible={popupErrorVisible}
                            onOk={onOk}
                            classNameColorIcon={popupClassNameColorIcon}
                            btnVisibleCancel={btnVisibleCancel}
                            onCancel={onCancel}
                            onCancelWithOk={onCancelWithOk ?? onCancel}
                            textOk={popupYesNo ? 'Да' : undefined}
                            textCancel={popupYesNo ? 'Нет' : undefined}
                />
                <Popup
                    visible={popupFindInnVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    onHiding={hidePop}
                    maxWidth={450}
                    maxHeight={'90%'}
                    height={'auto'}
                    titleRender={()=>PopupTitleWithIcon('dx-icon-fieldchooser', "Заполнить поля",hidePop)}
                >
                    <ScrollView width='100%' height='100%'>
                        <div className="row justify-content-around">
                            <div className="col-sm-12">
                                <p>Для ИНН:{selectedReq?.inn} найдены поля:</p>
                                {nameCompany &&
                                    <>
                                        <p>Наименование абонента:<br/>
                                            {nameCompany}</p>
                                    </>
                                }
                                {kpp &&
                                    <>
                                        {kppList.length > 1 && <>Выберите</>} KПП:
                                        <RadioGroup
                                            id="radio-group-with-selection"
                                            items={kppList}
                                            defaultValue={kppList[0]}
                                            onValueChanged={changeKPP}
                                        />
                                    </>
                                }
                                <Button className={'float-right ml-2'} text='Отмена' onClick={() => {
                                    hidePop()
                                }} />
                                <Button className={'float-right'} text='Заполнить' onClick={async () => {
                                    await saveOneFieldOnBlurFocus('name_company',nameCompany)
                                    await saveOneFieldOnBlurFocus('kpp',kpp)
                                    await getListZayavka()
                                    hidePop()
                                }} />
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
                <Popup
                    visible={popupRefusedVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title="Отказ от подписи"
                    maxWidth={600}
                    maxHeight={'90%'}
                    height={'auto'}
                    onHiding={hidePopRefused}
                    titleRender={()=>PopupTitleWithIcon(faKey, "Отказ от подписи",hidePopRefused)}
                >
                    <ScrollView width='100%' height='100%'>
                        <form onSubmit={onFormSubmitRefused} tabIndex={0} onKeyDown={(e) => {
                            if (e.key === 'Escape') hidePopRefused();
                        }}>
                            <TextBox
                                showClearButton={true}
                                value={refusedMessage}
                                labelMode='floating'
                                label={'Причина отказа'}
                                onValueChanged={(e) => setRefusedMessage(e.value)}>
                                <ValidatorDevex>
                                    {popupRefusedVisible && <RequiredRuleValidator message={'Обязательное поле'}/>}
                                </ValidatorDevex>

                            </TextBox>
                            <Button useSubmitBehavior={true} className={'float-right mt-4'} text='Отправить'/>
                        </form>
                    </ScrollView>
                </Popup>
            </>

            {(selectedReq.id_status !== undefined && selectedReq.id_status !== 10) &&
                <>
                    <div className="row round-button-only-icon mb-5">

                        <div className='col-12 font-weight-bold mb-2'>Документы к подписанию:</div>
                        {finalDog?.length === 0 &&
                            <div className={'col-12'}><i> Пока нет прикрепленного договора</i></div>
                        }
                        {finalDog?.length > 0 &&
                            finalDog.map((finalDog, i) =>
                                finalDog &&
                                <div key={finalDog.id + '' + i} className='hideOvarlayLayer col-12 mt-1'>
                                    <div className={'d-flex flex-row align-items-center'}>
                                        <div>
                                            <Button type='default' className='mr-1'
                                                    hint='Скачать всё архивом' icon={'download'}
                                                    onClick={async () => {
                                                        await downloadZip(finalDog.id);
                                                    }}></Button>
                                        </div>
                                        {finalDog?.client_sign_refused ?
                                            <span title='Отказались от подписи' className='p-2 danger'><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0.58681 16.5962L1.96378 18L10.982 8.80608C11.6929 9.23774 12.505 9.47589 13.3573 9.47589C14.5983 9.47589 15.7662 8.9847 16.6422 8.08698C18.4526 6.24129 18.4526 3.2346 16.6422 1.38891C15.7662 0.495838 14.5982 2.01491e-06 13.3573 1.90642e-06C12.1164 1.79794e-06 10.9484 0.491193 10.0724 1.38891C8.45629 3.03646 8.28658 5.61137 9.55679 7.45706L6.07728 11.0044L4.56891 9.4666L3.19194 10.8704L4.70031 12.4082L2.88534 14.2585L1.37697 12.7207L-9.26741e-07 14.1245L1.50837 15.6623L0.588561 16.6L0.58681 16.5962ZM11.4447 2.79259C11.9557 2.27163 12.6318 1.98882 13.3527 1.98882C14.0727 1.98882 14.7543 2.27627 15.2608 2.79259C16.312 3.86428 16.312 5.61042 15.2608 6.68759C14.7498 7.20855 14.0736 7.49136 13.3527 7.49136C12.6328 7.49136 11.9511 7.20391 11.4446 6.68759C10.3934 5.6159 10.3934 3.86976 11.4447 2.79259Z"/>
                                                        </svg></span>
                                            :
                                            <>
                                                <div className={'mr-1'}><PopSelectCert companyKeyName={finalDog.companyKeyName}
                                                                                       companyKey={finalDog.companyKey}
                                                                                       idFile={finalDog.id}
                                                                                       clientKey={!!finalDog.clientKeyName}
                                                                                       onSuccessSign={onSuccessSign}/>
                                                </div>

                                                <div>
                                                    <Button type='danger' className='mr-1' visible={!finalDog.clientKeyName}
                                                            hint='Отказаться от подписи документа' icon={'images/flash.svg'}
                                                            onClick={async () => {
                                                                setFinalDogId(finalDog.id)
                                                                setRefusedMessage('')
                                                                setPopupRefusedVisible(true)
                                                            }}></Button>
                                                </div>
                                            </>
                                        }
                                        <div className='ml-2'>
                                            {/*<strong>{finalDog.filename}</strong>*/}{/*<br/>
                                                        <i>Подписан сбытовой компанией: <b>{finalDog.companyKeyName ? 'Да' : 'Нет'}</b><span> <FontAwesomeIcon
                                                            icon={faKey}
                                                            color={finalDog.companyKeyName ? 'green' : 'red'}/></span>; </i>
                                                        <i>Подписан клиентом: <b>{finalDog.clientKeyName ? 'Да' : 'Нет'}</b></i>
                                                        <span><FontAwesomeIcon
                                                                icon={faKey}
                                                                color={finalDog.clientKeyName ? 'green' : 'red'}/></span>*/}
                                            <a title={`Открыть "${finalDog.filename}" в браузере в новом окне`} className="dashed" id="link1" href='/' onClick={async (e) => {e.preventDefault(); await downloadAsFile(finalDog.id, finalDog.filename); }}>{finalDog.filename}</a>
                                        </div>

                                    </div>
                                </div>

                            )
                        }
                        {finalDog?.length > 1 &&
                            <div className='col-12 mt-3'>
                                {/*<Button className='' hint='Отказ от подписи всех документов' type='default' icon='images/key-remove.svg' onClick={ async (e) => notify("Отказались от подписи всех документов", 'success', 5000)}></Button>*/}
                                <Button className='' text={'Скачать все документы'} hint='Скачать все документы' type='default' icon='export'
                                        onClick={async () => {
                                            await downloadZipAll(selectedReq.id);
                                        }}></Button>
                            </div>
                        }
                    </div>
                    <div className="mt20">
                        <label><b>Переписка по заявке:</b><LoadIndicator width={'24px'} height={'24px'} visible={loadingMessage}/></label>
                        <div style={{height: '350px',border: '1px solid lightgray',overflowY: 'auto', padding: '10px'}}>
                            {
                                messages.map((message, i) => {
                                    return <div key={i}>
                                        <label><b>[{formatTimestamp(new Date(message.date_create))}] {message.type_message === 0 ? (user.firstName ? user.firstName+' '+user.lastName:user.lastName) : message.username}:</b></label>
                                        <p>{message.text_message}</p>
                                        {message.attachments?.map((attach) => <span key={attach.id}>
                                            <a href="/" id={attach.id} onClick={async (e) => {
                                                e.preventDefault();
                                                await downloadAkt(attach.id, false)
                                            }}>{attach.filename}</a>; </span>)}
                                    </div>

                                })
                            }
                        </div>
                        <div>
                            <form onSubmit={onSendMessage}>
                                <Form ref={formMessageRef} colCount={2} labelMode={'floating'} formData={messageFormData.current} >
                                    <Item dataField="message" editorType='dxTextArea' editorOptions={{autoResizeEnabled: true}}>
                                        <Label text={"Новое сообщение"}/>
                                    </Item>
                                        <GroupItem>
                                            <Item>
                                                <ExtFileUploader  selectedReqId={selectedReq.id ?? null} ref={extFileUploaderPerepiskaRef} setfile={(e) => messageFormData.current.attachments = e }></ExtFileUploader>
                                            </Item>
                                        </GroupItem>
                                    <EmptyItem/>
                                    <ButtonItem
                                        horizontalAlignment="right" cssClass='mt-2'
                                    >
                                        <ButtonOptions
                                            type={'default'}
                                            useSubmitBehavior={true}
                                            text="Отправить"
                                            icon="email"
                                        />
                                    </ButtonItem>
                                </Form>
                            </form>
                        </div>
                    </div>
                </>
            }
        </div>
    )

}

export default AddDogovorExtPage


